import { useMemo } from 'react';
import { useUserData } from 'store/useUserData';
import { resolveToDoPermissions, type ToDoPermissions } from '../utils/todoPermission';
import type { SecurityRolePermission } from 'tests/services/permissionService';

export function useToDoPermissions(): ToDoPermissions {
	const { currentUserRole } = useUserData();

	return useMemo(
		() =>
			resolveToDoPermissions(
				(currentUserRole?.securityRolePermission ?? []) as SecurityRolePermission[]
			),
		[currentUserRole?.securityRolePermission]
	);
}
